import { render, staticRenderFns } from "./GiftPanel.vue?vue&type=template&id=351d99c4&"
import script from "./GiftPanel.vue?vue&type=script&lang=js&"
export * from "./GiftPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports